// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let FormV5 = require("../../../uikit/reason/atoms/Form/FormV5.bs.js");
let ViewStack = require("../../../reason/common/ViewStack.bs.js");
let Form__Label = require("../../../uikit/reason/atoms/Form/Form__Label.bs.js");
let Form__Radio = require("../../../uikit/reason/atoms/Form/Form__Radio.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
let TMPUIKIT____CssGrid__Jsx3 = require("../../../temporaryUIKit/TMPUIKIT___CssGrid/TMPUIKIT____CssGrid__Jsx3.bs.js");
let PropertyWizardRelayPrivacy_draft_graphql = require("../../../__generated__/PropertyWizardRelayPrivacy_draft_graphql.bs.js");

let convertFragment = PropertyWizardRelayPrivacy_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPrivacy_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPrivacy_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPrivacy_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPrivacy_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment_localDraftPropertyType_decode = PropertyWizardRelayPrivacy_draft_graphql.Utils.localDraftPropertyType_decode;

let DraftFragment_localDraftPropertyType_fromString = PropertyWizardRelayPrivacy_draft_graphql.Utils.localDraftPropertyType_fromString;

let DraftFragment = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let defaultCopy = {
  question: "What information do you want to share with other agents?",
  showIdentityDescription: "Other agents will see your identity.",
  hideIdentityTitle: "Hide my name",
  hideIdentityDescription: "Other agents won't know who you are, but can request information from you. You can choose to share your identity in conversations."
};

let broadcastQuietSellerAnonymousCopy = {
  question: "Should your name stay hidden for this broadcast?",
  showIdentityDescription: "Other agents will see your identity on this broadcast.",
  hideIdentityTitle: "Keep my name hidden",
  hideIdentityDescription: "Other agents won't know who you are, but can request information from you. You can choose to share your identity in conversations."
};

function shouldShowPrivacyField(mode, propertyType, initialAnonymousPropertyValue) {
  if (propertyType !== "FOR_SALE") {
    return false;
  }
  if (typeof mode !== "object") {
    return true;
  }
  switch (mode.TAG) {
    case "Edit" :
    case "Rebroadcast" :
      return initialAnonymousPropertyValue;
    case "BroadcastQuietSeller" :
      switch (mode._1.privacySetting) {
        case "ANONYMOUS" :
          return true;
        case "HIDDEN" :
        case "NORMAL" :
          return false;
      }
  }
}

function getCopy(mode) {
  if (typeof mode !== "object") {
    return defaultCopy;
  }
  if (mode.TAG !== "BroadcastQuietSeller") {
    return defaultCopy;
  }
  switch (mode._1.privacySetting) {
    case "ANONYMOUS" :
      return broadcastQuietSellerAnonymousCopy;
    case "HIDDEN" :
    case "NORMAL" :
      return;
  }
}

function PropertyWizardRelay__Privacy(props) {
  let match = PropertyWizardFormRelay.Context.use();
  let mode = match.mode;
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayPrivacy_draft_graphql.node, convertFragment, props.draft);
  let match$1 = React.useState(() => draft.draftProperty.anonymousProperty);
  let initialAnonymousPropertyValue = match$1[0];
  let anonymousBroadcastPropertiesEnabled = PropertyWizardRelayUtils.useAnonymousBroadcastPropertiesEnabled();
  let updateDraftProperty = PropertyWizardFormRelay.useUpdateDraftProperty();
  let showPrivacyField = shouldShowPrivacyField(mode, draft.draftProperty.propertyType, initialAnonymousPropertyValue);
  let alreadyAnonymous;
  if (typeof mode !== "object") {
    alreadyAnonymous = false;
  } else {
    switch (mode.TAG) {
      case "Edit" :
      case "Rebroadcast" :
        alreadyAnonymous = initialAnonymousPropertyValue;
        break;
      case "BroadcastQuietSeller" :
        alreadyAnonymous = false;
        break;
    }
  }
  let match$2 = anonymousBroadcastPropertiesEnabled || alreadyAnonymous;
  let match$3 = getCopy(mode);
  if (showPrivacyField && match$2 && match$3 !== undefined) {
    return JsxRuntime.jsx(FormV5.FormSection.make, {
      children: JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
        width: 12,
        children: [
          JsxRuntime.jsx(Form__Label.make, {
            labelText: "Privacy"
          }),
          JsxRuntime.jsxs(ViewStack.make, {
            space: {
              NAME: "px",
              VAL: "p20"
            },
            children: [
              JsxRuntime.jsx("p", {
                children: match$3.question
              }),
              JsxRuntime.jsx(Form__Radio.RadioCardList.make, {
                selected: draft.draftProperty.anonymousProperty,
                items: [
                  {
                    title: "Share my identity",
                    description: match$3.showIdentityDescription,
                    value: false
                  },
                  {
                    title: match$3.hideIdentityTitle,
                    description: match$3.hideIdentityDescription,
                    value: true
                  }
                ],
                name: "privacy",
                toValue: v => {
                  if (v) {
                    return "hide";
                  } else {
                    return "show";
                  }
                },
                onChange: anonymousProperty => updateDraftProperty(draftProperty => {
                  let newrecord = {...draftProperty};
                  newrecord.anonymousProperty = anonymousProperty;
                  return newrecord;
                })
              })
            ]
          })
        ]
      })
    });
  } else {
    return null;
  }
}

let FormSection;

let Cell;

let make = PropertyWizardRelay__Privacy;

exports.FormSection = FormSection;
exports.Cell = Cell;
exports.DraftFragment = DraftFragment;
exports.defaultCopy = defaultCopy;
exports.broadcastQuietSellerAnonymousCopy = broadcastQuietSellerAnonymousCopy;
exports.shouldShowPrivacyField = shouldShowPrivacyField;
exports.getCopy = getCopy;
exports.make = make;
/* react Not a pure module */
